import { asset as algorand } from '@exodus/algorand-meta'

const EXODUS_OPT_IN_FAUCET_ADDRESSES = [
  // Same in Sandbox and Production.
  'LNFHKV2SKKIFJ46RIQP6PNB467ALWG5EEED7NDZOCK2ADAPZPL645SGTPI',
]

const smallTxAmount = algorand.currency.defaultUnit('0.000001')

export const isAlgorandTx = (tx) => tx.coinName === 'algorand'

export const isAlgorandTokenTx = ({ tx, asset }) =>
  tx.coinName === asset.name && asset.assetType === 'ALGORAND_TOKEN'

export const isAlgorandRewardTx = (tx) => isAlgorandTx(tx) && tx?.data?.reward && !tx?.data?.memo

export const isAlgorandAutoClaimTx = (tx) =>
  isAlgorandTx(tx) && tx.data && !tx.data.reward && Number(tx.data.rewardAmount || 0) > 0

export const isAlgorandTokenOptInTx = ({ tx, asset }) =>
  isAlgorandTokenTx({ tx, asset }) && tx?.data?.isTokenOptIn

export const isAlgorandWhitelistedTx = ({ tx, asset }) =>
  isAlgorandTokenTx({ tx, asset }) && tx?.data?.isWhitelistedTx

export const isAlgorandRevertedTx = ({ tx, asset }) =>
  isAlgorandTokenTx({ tx, asset }) && tx?.data?.isReverted

export const isAlgorandContractTx = ({ tx, asset }) =>
  (isAlgorandTx(tx) || isAlgorandTokenTx({ tx, asset })) && tx?.data?.unparsed

const matchAddress = ({ assetName, addresses, checkAgainst }) => {
  addresses = [addresses].flat().filter((a) => !!a)
  let checkAgainstArray = [checkAgainst].flat()

  addresses = addresses.map((address) => address.toLowerCase())
  checkAgainstArray = checkAgainstArray.map((address) => address.toLowerCase())

  return addresses.some((address) => checkAgainstArray.includes(address))
}

export const isExodusAlgorandAirdrop = (tx, airdropAddresses) =>
  isAlgorandTx(tx) &&
  matchAddress({
    assetName: 'algorand',
    addresses: tx.from,
    checkAgainst: airdropAddresses || EXODUS_OPT_IN_FAUCET_ADDRESSES,
  })

const getAdditionalAlgorandRewardsTxs = (tx, algorand) => {
  const { data, ...txCommon } = tx.toJSON()
  return tx.update({
    ...txCommon,
    coinAmount: algorand.currency.baseUnit(data.rewardAmount),
    data,
  })
}

const getAdditionalAlgorandAutoClaimTxs = (tx, algorand) => {
  const { data, ...txCommon } = tx.toJSON()
  return [
    tx.update({
      ...txCommon,
      coinAmount: algorand.currency.baseUnit(data.rewardAmount),
      data: { ...data, reward: true, activityIndex: 0 },
    }),
    tx.update({
      ...txCommon,
      data: {
        ...data,
        activityIndex: 1,
      },
    }),
  ]
}

export const getActivityTxs = ({ txs, asset }) => {
  const isSmallValueTx = (tx) =>
    tx?.coinName === asset.name && !tx.sent && tx.coinAmount.abs().lte(smallTxAmount)

  return txs.flatMap((tx) => {
    if (isAlgorandAutoClaimTx(tx)) {
      return getAdditionalAlgorandAutoClaimTxs(tx, asset)
    }

    if (isAlgorandRewardTx(tx)) {
      return getAdditionalAlgorandRewardsTxs(tx, asset)
    }

    if (isSmallValueTx(tx)) {
      return [] // filter small value tx
    }

    return tx
  })
}
